/**
 * companyVertical.js — Detección de vertical de la empresa a partir
 * del objeto `user` devuelto por `useAuth()`.
 *
 * Fuente de verdad de los valores aceptados: `backend/core/plan_access.py`
 * + el modelo `Company` (campos `business_type` y `industry`).
 *
 * Reglas de inspección (en orden de prioridad):
 *   1. `user.industry`            (top-level)
 *   2. `user.company.industry`    (nested cuando el backend devuelve embed)
 *   3. `user.business_type`       (top-level)
 *   4. `user.company.business_type`
 *
 * Todos los helpers son defensivos: aceptan `null`/`undefined` sin
 * romperse y devuelven `false` en ese caso.
 */

export const getCompanyVertical = (user) => {
  const industry = String(user?.industry || user?.company?.industry || '').toLowerCase();
  const businessType = String(user?.business_type || user?.company?.business_type || '').toLowerCase();
  return { industry, businessType };
};

export const isCarDealerUser = (user) => {
  const { industry, businessType } = getCompanyVertical(user);
  return (
    industry === 'automotive'
    || industry === 'car_dealer'
    || industry === 'car-dealer'
    || businessType === 'car_dealer'
    || businessType === 'car-dealer'
  );
};

export const isDeveloperUser = (user) => {
  const { businessType } = getCompanyVertical(user);
  return businessType === 'developer' || businessType === 'franchise';
};

export const isEducationUser = (user) => {
  const { industry, businessType } = getCompanyVertical(user);
  return (
    industry === 'education'
    || businessType === 'school'
    || businessType === 'university'
    || businessType === 'colegio'
    || businessType === 'education'
  );
};

/** General (cualquier negocio) + Educación: catálogo de productos/servicios. */
export const isCatalogVerticalUser = (user) => {
  if (isEducationUser(user)) return true;
  const { industry, businessType } = getCompanyVertical(user);
  return (
    industry === 'generic'
    || industry === 'comercial'
    || industry === 'retail'
    || businessType === 'generic'
    || businessType === 'retail'
  );
};

export const isRealEstateUser = (user) => {
  const { industry } = getCompanyVertical(user);
  return industry === 'real_estate';
};
